export default "__VITE_ASSET__DBiM7VLg__"